import { useState } from "react";
import { useTheme } from "../../../theme/ThemeProvider";
import { useSelector } from "react-redux";
import Logo from "./Logo";
import SearchModal from "../search/SearchModal";
import MobileDrawer from "../nav/MobileDrawer";
import { FiMenu } from "react-icons/fi";
import AccountSection from "../account/AccountSection";

const Header = ({ onLoginClick }) => {
  const { isDarkMode } = useTheme();
  const { categories } = useSelector((state) => state.home);

  const [drawerVisible, setDrawerVisible] = useState(false);

  const getPlaceholderTexts = () => {
    if (!categories || categories.length === 0) {
      return [
        "Search for Mobile Phones...",
        "Search for Tablets...",
        "Search for Smart Watches...",
      ];
    }

    return categories.map(
      (cat) => `Search for ${cat.display_name || cat.name}...`,
    );
  };


  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 ${
          isDarkMode
            ? "bg-gray-900 border-gray-800"
            : "bg-white border-gray-200"
        } border-b`}
      >
        <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div className="flex items-center justify-between py-2">
            <Logo />

            {/* The desktop search was previously commented out, so it never rendered. */}
            <div className="hidden md:block flex-1 min-w-0 max-w-xl mx-4 lg:mx-8">
              <SearchModal
                isDesktop={true}
                isDarkMode={isDarkMode}
                placeholderTexts={getPlaceholderTexts()}
              />
            </div>

            <div className="flex items-center gap-1.5">
              <AccountSection isDarkMode={isDarkMode} />
              <button
                onClick={() => setDrawerVisible(true)}
                className="md:hidden p-1.5 rounded-md hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
              >
                <FiMenu
                  size={18}
                  className="text-gray-600 dark:text-gray-200"
                />
              </button>
            </div>
          </div>

          {/* On phones, place the existing product search just below the top navigation. */}
          <div className="md:hidden pb-3">
            <SearchModal
              inline={true}
              isDarkMode={isDarkMode}
              placeholderTexts={getPlaceholderTexts()}
            />
          </div>
        </div>
      </header>

      <MobileDrawer
        visible={drawerVisible}
        onClose={() => setDrawerVisible(false)}
        isDarkMode={isDarkMode}
        categories={categories}
      />
    </>
  );
};

Header.defaultProps = {
  onLoginClick: () => {},
};

export default Header;
